import { render, staticRenderFns } from "./TickerTextBanner.vue?vue&type=template&id=98c5a9d4&lang=pug&"
import script from "./TickerTextBanner.vue?vue&type=script&lang=js&"
export * from "./TickerTextBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports